<div class=" text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Update Cluster</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>

  <div class="modal-body">
    <form spellcheck="false" autocomplete="off" [formGroup]="updateClusterForm" (ngSubmit)="onSubmit(updateClusterForm)">

      <mat-form-field style="width: 100%">
        <mat-label>Number of static compute nodes</mat-label>
        <input matInput
               placeholder="Number of static compute nodes"
               formControlName="numberOfStaticComputeNodes"
               matTooltip="Only nono-zero positive numbers allowed" />
        <mat-error *ngIf="updateClusterForm.get('numberOfStaticComputeNodes').invalid">Entered value is not Valid.</mat-error>
      </mat-form-field>

      <mat-form-field style="width: 100%">
        <mat-label>Number of dynamic compute nodes</mat-label> 
        <input matInput
               placeholder="Number of dynamic compute nodes"
               formControlName="numberOfDynamicComputeNodes"
               matTooltip="Only nono-zero positive numbers allowed" />
        <mat-error *ngIf="updateClusterForm.get('numberOfDynamicComputeNodes').invalid">Entered value is not Valid.</mat-error>
      </mat-form-field>

      <mat-form-field style="width: 100%">
        <mat-label>Node Size</mat-label>
        <mat-select formControlName="nodeSize">
          <mat-option *ngFor="let config of nodeConfigNames" value="{{config?.instanceCode}}" (click)="hpcConfigChanged(config?.hpcConfigId)">{{config?.instanceCode}}</mat-option>
        </mat-select>
        <mat-hint align="start">{{ selectedHpcConfig?.description }}</mat-hint>
      </mat-form-field>

      <div style="width: 100%; text-align: center; margin-top: 10%">
        <label for="">{{ noteMessage }}</label>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary"
            [disabled]="!updateClusterForm.valid"
            (click)="onSubmit(updateClusterForm)">
      Submit
    </button>
  </div>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="default"
             zIndex="1"
             color="var(--s-primary-color)"
             type="ball-spin"
             [fullScreen]="false"
             name="updateCredential"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
